<template>
  <div class="about">
    <h1>This is an about page</h1>
    Current User: {{CurrentUser}}
    <v-btn @click="updatecomuni">Aggiorna Comuni</v-btn>
    <v-btn @click="carica">Carica Comuni</v-btn>
{{Object.entries(this.$store.state.comuni.data).length}} {{$store.state.comuni2}}
  </div>
</template>
<script>
import { Firebase } from '../Firebase.js'
export default {
     data: () => ({
         com:'[1,2,3]'
     }),
     computed:{
       CurrentUser(){
         return Firebase.auth().currentUser
       }
     },
    mounted(){
        console.log("monto daticomuni")
        //this.$store.dispatch('comuni/fetchAndAdd')

    },
    methods:{
        carica(){
        
        
        
        this.$store.dispatch('comuni/fetch', { clauses: { limit: 50 } })
        //this.$store.dispatch('comuni/fetchAndAdd')


        },

        updatecomuni(){
          this.$store.dispatch("UpdateComuniFromHR")          
          .then(r=>{
              console.log(r);
          })
        .catch(r=>{
              console.log(r);
          });
        }
        
    }
}
</script>